import React from "reactn";
import {
    Tooltip,
    Icon
} from "@material-ui/core";
import { themeColors } from "js/react/sharedStyles";
import styled from "styled-components";
import { Gap5 } from "js/react/components/Gap";

const TooltipIcon = styled.div`
  background: white;
  font-size: 12px;
  border: solid 1px ${themeColors.ui_blue};
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${themeColors.ui_blue};
  .MuiIcon-root {
    font-size: 11px;
    font-weight: 500;
  }
`;

export default function InfoToolTip({ label, title, labelStyle, id }) {
    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            {label && <label style={labelStyle} htmlFor={`${id}`}>{label}</label>}
            <Tooltip title={title} placement="right-start">
                <TooltipIcon><Icon>question_mark</Icon></TooltipIcon>
            </Tooltip>
        </div>
    );
}
